export default {
    page_title: "Tareas",
    add_button: "Agregar",
    created_tasks: "Tareas Creadas",
    completed_tasks: "Tareas Completadas",
    on_time_tasks: "Completadas a Tiempo",
    conversions: "Conversiones",
    conversion_rate: "Tasa de Conversión",
    incentivized_revenue: "Facturación Incentivada",
    by_user: "Por Usuario",
    by_automation: "Por Automatización",
    name: "Nombre",
    created: "Creadas",
    completed: "Completadas",
    on_time: "Completadas a Tiempo",
    no_data_for_period: "Sin datos para el período",
    automation_filter: "Automatización",
    task_due_date: "Plazo de la tarea",
    created_date: "Fecha de creación",
    completed_date: "Fecha de finalización",
};
